import { EnumConfig } from 'angular-odata';

//#region ODataApi Imports
import { VertriebsType } from './vertriebstype.enum';
//#endregion

export const VertriebsTypeConfig = {
  name: "VertriebsType",
  members: VertriebsType
} as EnumConfig<VertriebsType>;